import { db, auth } from "./firebase";
import {
  ref,
  onValue,
  query,
  limitToFirst,
  startAfter,
  orderByChild,
  get,
  equalTo,
} from "firebase/database";

// Fetch monitor data from Firebase Realtime DB
export const fetchData = (
  setCellVoltages,
  setLastUpdateTime,
  setVoltage,
  setChargingCurrent,
  setCapacity,
  setTemperature,
  currentUser
) => {
  if (!currentUser) return;

  const uid = auth.currentUser?.uid;
  if (!uid) return;

  const dbRef = ref(db, `UsersData/${uid}/readings`);

  onValue(dbRef, (snapshot) => {
    const data = snapshot.val();

    if (!data) {
      console.warn("No data found for user:", uid);
      return;
    }

    const cellVoltages = data.cellVoltages || {};
    const epochTime = data.epochTime || 0;
    const batteryVoltage = data.batteryVoltage || 0;
    const batteryCapacity = data.ActualBatteryCapacity || 0;
    const chargingCurrent = data.chargingCurrent || 0;
    const temperature = data.batteryTemperature || 0;

    setVoltage(batteryVoltage);
    setCapacity(batteryCapacity);
    setChargingCurrent(chargingCurrent);
    setTemperature(temperature);

    const roundedCellVoltages = Object.values(cellVoltages).map((voltage) =>
      parseFloat(voltage).toFixed(2)
    );
    
    setCellVoltages(roundedCellVoltages);

    const formattedTime = epochTime > 0 
      ? new Date(epochTime * 1000).toLocaleString()
      : "Invalid time";
    setLastUpdateTime(formattedTime);

    
  }, (error) => {
    console.error("Error fetching data:", error);
  });
};

// Fetch paginated users data from Firebase Realtime DB
export const fetchUsersData = async (offset, limit) => {
  const usersRef = ref(db, "UsersData");

  const paginatedQuery = query(
    usersRef,
    orderByChild("orderId"),
    startAfter(offset || 0),
    limitToFirst(limit)
  );

  try {
    const snapshot = await get(paginatedQuery);

    const users = [];

    if (snapshot.exists()) {
      const data = snapshot.val();

      Object.keys(data).forEach((key) => {
        const userData = data[key];
        const filteredUser = {
          id: key,
          name: userData.name || "",
          address: userData.address || "",
          dateIssued: userData.dateIssued || "",
          capacity: userData.capacity || "",
          contact: userData.contact || "",
          voltage: userData.voltage || "",
          monitor: userData.monitor || "",
          orderId: userData.orderId || "",
        };
        users.push(filteredUser);
      });
    }

    return users;
  } catch (error) {
    console.error("Error fetching users data:", error);
    return [];
  }
};

export const fetchUserDetails = (
  setVoltageChartData,
  setCapacityChartData,
  setCurrentChartData,
  setCellVoltages,
  setLastUpdateTime,
  setLatestValues,
  orderId,
  setUserDetails
) => {
  const usersRef = ref(db, "UsersData");
  const orderQuery = query(usersRef, orderByChild("orderId"), equalTo(orderId));

  onValue(orderQuery, (snapshot) => {
    const userData = snapshot.val();

    if (userData) {
      const uid = Object.keys(userData)[0];
      const user = userData[uid];

      setUserDetails({
        name: user.name,
        contact: user.contact,
      });

      const dbRef = ref(db, `UsersData/${uid}`);

      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();

        if (data) {
          const currentTimestamp = Math.floor(Date.now() / 1000);
          const oneDayAgo = currentTimestamp - 2 * 24 * 60 * 60; // Last 7 days

          const filteredData = Object.values(data).filter(
            (reading) => reading.timestamp >= oneDayAgo
          );
          console.log(oneDayAgo, filteredData);

          if (filteredData.length > 0) {
            const latestReading = filteredData[filteredData.length - 1];
            const labelData = filteredData.map((data) =>
              new Date(data.timestamp * 1000).toLocaleTimeString()
            );

            const voltageChartData = {
              labels: labelData,
              data: filteredData.map((data) => data.batteryVoltage),
            };
            const capacityChartData = {
              labels: labelData,
              data: filteredData.map((data) => data.batteryCapacity),
            };
            const currentChartData = {
              labels: labelData,
              data: filteredData.map((data) => data.chargingCurrent),
            };

            setVoltageChartData(voltageChartData);
            setCapacityChartData(capacityChartData);
            setCurrentChartData(currentChartData);
            setCellVoltages(Object.values(latestReading.cellVoltages));

            setLastUpdateTime(
              new Date(latestReading.timestamp * 1000).toLocaleString()
            );

            setLatestValues({
              voltage: latestReading.batteryVoltage,
              capacity: latestReading.batteryCapacity,
              current: latestReading.chargingCurrent,
            });
          }
        }
      });
    } else {
      console.error("No user found with the provided orderId.");
    }
  });
};
